import { focusOnElement, getHTMLElementFromRoot } from "../helper";
import { focusTimeout } from "../constants/timeouts";

export function focusOnBurgerButton(): void {
  setTimeout(() => {
    focusOnElement(
      getHTMLElementFromRoot("phn-burger-button phn-p-button-pure"),
    );
  }, focusTimeout);
}
